import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll the element matching `location.hash` into view on mount and
 * whenever the hash changes. Used by Landing + Pricing pages so that
 * MarketingNav's hash links (e.g. /#features, /pricing#faq) actually
 * scroll the user to the right section after navigation.
 */
export default function useScrollToHash() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = hash.startsWith("#") ? hash.slice(1) : hash;
    // Defer one tick so the section has rendered.
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 50);
    return () => clearTimeout(t);
  }, [hash]);
}
